import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import InputRadioBox from './InputRadioBox'

function InputWindows (props) {

  const manager = usePortManager()

  return (
    <React.Fragment>
      {manager.windowOptions.map(value => <InputRadioBox key={value} name={'windows'} value={value} size={'half'}
                                                         image={value !== 'no_windows'} updatesPrice={true}/>)}
    </React.Fragment>
  )
}

export default observer(InputWindows)